import { AdminActionDisabledTooltip } from "src/components/AdminActionDisabledTooltip/AdminActionDisabledTooltip";
import {
  BlockContent,
  Description,
  IconContent,
  Title,
  UnstyledButton,
  Wrapper,
} from "./PostShiftOption.styles";

export interface PostShiftOptionProps {
  type: "block-shifts" | "per-diem";
  heading: string;
  description: string;
  icon: JSX.Element;
  isAdmin: boolean;
  onClick: () => void;
}

export function PostShiftOption({
  heading,
  description,
  icon,
  onClick,
  isAdmin,
}: PostShiftOptionProps) {
  return (
    <AdminActionDisabledTooltip disabled={isAdmin}>
      <UnstyledButton onClick={onClick} disabled={isAdmin}>
        <Wrapper>
          <BlockContent>
            <Title>{heading}</Title>
            <Description>{description}</Description>
          </BlockContent>
          <IconContent>{icon}</IconContent>
        </Wrapper>
      </UnstyledButton>
    </AdminActionDisabledTooltip>
  );
}
